// extracted by mini-css-extract-plugin
module.exports = {"btn":"BlackBoxButton_btn__1Bhiv"};